import { REVENUE, USER, GEOGRAPHIC, SUBSCRIPTION, SLIDER_MAX_VALUE } from "../../Constant/constant";
import { Slider, Radio, RadioGroup, FormControlLabel, Typography } from "@mui/material";
import Select from "react-select";

export const filterOptionsMapping = {
  [REVENUE]: [
    {
      filterName: "Default View",
      type: "defaultView",
      defaultValue: null,
      active: true,
      sliderTrue: false,
      name: null,
      graphType: "bar",
      id: 23,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Top Clients",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "client",
      graphType: "bar",
      id: 1,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Industries",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "industry",
      graphType: "bar",
      id: 2,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Products",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "product",
      graphType: "bar",
      id: 3,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Locations",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "location",
      graphType: "bar",
      id: 4,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Client Type",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "clientType",
      graphType: "bar",
      id: 5,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Entity",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "entity",
      graphType: "bar",
      id: 6,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
  ],
  [USER]: [
    {
      filterName: "Default View",
      type: "defaultView",
      defaultValue: null,
      active: true,
      sliderTrue: false,
      name: null,
      graphType: "bar",
      id: 24,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Active Users",
      type: "slider",
      defaultValue: null,
      active: false,
      toggleTrue: false,
      name: "activeUser",
      graphType: "bar",
      value1: "monthly",
      value2: "daily",
      id: 7,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Groups With Most Users",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "topGroups",
      graphType: "bar",
      id: 8,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Groups With Most Activity",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "groupActivity",
      graphType: "bar",
      id: 9,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Industry",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "industry",
      graphType: "bar",
      id: 10,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Products",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "topProducts",
      graphType: "bar",
      id: 11,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Locations",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "location",
      graphType: "bar",
      id: 12,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Subscription Type",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "subscriptionType",
      graphType: "bar",
      id: 27,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
  ],
  [SUBSCRIPTION]: [
    {
      filterName: "Default View",
      type: "defaultView",
      defaultValue: null,
      active: true,
      sliderTrue: false,
      name: null,
      graphType: "bar",
      id: 25,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Top Products",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "products",
      graphType: "bar",
      id: 13,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Resources",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "resources",
      graphType: "bar",
      id: 14,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Industry",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "industry",
      graphType: "bar",
      id: 15,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Top Locations",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: true,
      name: "location",
      graphType: "bar",
      id: 16,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Client Types",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "clientType",
      graphType: "bar",
      id: 17,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Subscription Type",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "subscriptionType",
      graphType: "bar",
      id: 26,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
  ],
  [GEOGRAPHIC]: [
    {
      filterName: "Activity",
      type: "defaultView",
      defaultValue: null,
      active: true,
      sliderTrue: false,
      name: "activity",
      graphType: "bar",
      id: 32,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Client",
      type: "slider",
      defaultValue: 10,
      active: false,
      sliderTrue: false,
      name: "client",
      graphType: "bar",
      id: 18,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: true,
    },
    {
      filterName: "Industry",
      type: "dropDown",
      defaultValue: null,
      active: false,
      sliderTrue: true,
      name: "industry",
      graphType: "bar",
      id: 19,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
      placeHolder: "Select Industries",
      isMulti: true,
    },
    {
      filterName: "Revenue",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "revenue",
      graphType: "bar",
      id: 21,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Client Type",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "clientType",
      graphType: "bar",
      id: 22,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
    {
      filterName: "Subscription Type",
      type: "slider",
      defaultValue: null,
      active: false,
      sliderTrue: false,
      name: "subscriptionType",
      graphType: "bar",
      id: 33,
      maxValue: SLIDER_MAX_VALUE,
      activeInput: false,
    },
  ],
};

export const renderInputs = (item, type, handleChange, dateRange, dropDownValues) => {
  switch (type) {
    case "slider": {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Slider
            max={item.maxValue}
            onChange={(e, value) => {
              handleChange(item.filterName, value, "defaultValue");
            }}
            value={item.defaultValue}
            aria-label="Default"
            valueLabelDisplay="auto"
          />
        </div>
      );
    }
    case "toggle2": {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          {!dateRange && (
            <RadioGroup
              row
              value={item.defaultValue}
              onChange={(e) => handleChange(item.filterName, e.target.value, "defaultValue")}
            >
              <FormControlLabel
                value={item.value1}
                control={<Radio size="small" />}
                label={<Typography fontSize="0.75rem">Monthly</Typography>}
              />
              <FormControlLabel
                value={item.value2}
                control={<Radio size="small" />}
                label={<Typography fontSize="0.75rem">Daily</Typography>}
              />
            </RadioGroup>
          )}
        </div>
      );
    }
    case "defaultView": {
      return <div></div>;
    }
    case "dropDown": {
      const handleDropDownChange = (value) => {
        let ids = [];
        if (Array.isArray(value)) {
          ids = value.map((e) => e.value);
        } else if (value) {
          ids = [value.value];
        }
        handleChange(item.filterName, ids, "defaultValue");
      };
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Select
            options={dropDownValues}
            isMulti={item.isMulti || false}
            isSearchable={item?.serachable || false}
            placeholder={item?.placeHolder}
            filterOption={(option, inputValue) =>
              option?.data?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
            }
            onChange={handleDropDownChange}
          />
        </div>
      );
    }
  }
};
